import raw from './rawPhotosServiceClient';

export default {
  assets: {
    downloadOne: (projectUid, photoUid, type) => {
      return raw.get(
        `/v0/project/${projectUid}/photo/${photoUid}/asset/${type}?for_download=true`,
        { redirect: 'follow' },
      );
    },
  },
};
